import {DisplayAdContainer} from '../../../../common/containers/DisplayAdContainer/DisplayAdContainer';
import {DisplayAdItem} from '../../../../graphql/generated/types';
import {CommonItemProps} from '../../type';

export function Da({item}: CommonItemProps) {
  const {displayAd} = item as DisplayAdItem;
  return <DisplayAdContainer displayAd={displayAd} />;
}
